import request from '@/utils/request';
// 登录
export function ForgetPwd(data) {
    return request({
        url: '/some/forgetPwd/index',
        method: 'POST',
        data
    });
}
